import DOMPurify from 'dompurify';

const SecurityUtil = {
  /**
   * 정보 공개 여부 판단
   * @param {*} gclientId 
   * @returns 
   */
  isPublicAbountMe : (gclientId, securityOpenedGClientsAboutMe) => {
    // console.log({ gclientId, securityOpenedGClientsAboutMe })
    const openedGClients = securityOpenedGClientsAboutMe.filter(gclient => gclient.id === gclientId);
    if (openedGClients.length > 0) {
      return true;
    } else {
      return false;
    }
  },

  /**
   * HTML 콘텐츠를 XSS 공격으로부터 안전하게 정제
   * @param {string} content - 정제할 HTML 콘텐츠
   * @returns {string} 정제된 HTML 콘텐츠
   */
  sanitizeHtml: (content) => {
    if (!content) return '';

    // 이미지 태그 처리
    const processedContent = content.replace(
      /<img[^>]*src="([^"]*)"[^>]*>/g,
      '<img src="$1" style="cursor: nwse-resize;" width="520">'
    );
    //console.log("processedContent => ", processedContent);
    return DOMPurify.sanitize(processedContent, {
      ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'span', 'div', 'img'],
      ALLOWED_ATTR: ['style', 'class', 'src', 'width'],
      ALLOWED_STYLES: ['color', 'background-color', 'font-size', 'font-weight', 'text-align']
    });
  }
}

export default SecurityUtil;